// @flow
import logError from 'mz-utils/logError'
import verifyFlight from 'mz-sdk/services/flights/verifyFlight'
import omitEmptyFields from 'mz-utils/omitEmptyFields'

// Types
import type { Flight } from 'mz-sdk/services/flights/getFlights'
import type { FlightInfo } from '../BasicFlightField'

type Result = {
  message: string,
  title: ?string,
}

/**
 * Validate given flight object by given properties - flight
 * information and search information.
 * Returns an error which will return an object with validation
 * results or undefined if everything is OK
 * @param  {Object} flight:     Flight
 * @param  {Object} flightInfo: FlightInfo
 * @param  {Object} searchId:   string
 * @return {Promise<?Object>}
 */
const validateFlightValue = async (
  flight: Flight,
  flightInfo: FlightInfo,
  searchId: string
): Promise<?Result> => {
  const airportCode =
    (flightInfo.flightDirection === 'arr'
      ? flight.destination
      : flight.origin) || flightInfo.airportCode

  const params = omitEmptyFields({
    return_voyage: !!flightInfo.returnVoyage,
    pickup_datetime: flightInfo.pickupDatetime,
    flight_datetime: flightInfo.flightDatetime,
    airline_code: flight.airlineCode || flight.flightCode.substring(0, 2),
    airport_code: airportCode,
    flight_direction: flightInfo.flightDirection,
    flight_number: flight.flightNumber,
    search_id: searchId,
  })

  try {
    const result = await verifyFlight(params)
    const { is_valid: valid } = result
    if (!valid) {
      return {
        message: result.message,
        title: result.message_title,
      }
    }
  } catch (e) {
    logError(e)
    return null
  }

  return null
}

export default validateFlightValue
